<template>
  <div class="bootstrap-tagsinput">
    <div class="input-tags-field">
      <input
        v-model="input"
        v-bind="$attrs"
        :placeholder="placeholder"
        type="search"
        class="form-control input-tags-input"
        autocomplete="off"
        @keydown="handleKeydown"
        @blur="handleBlur"
      />
      <button
        v-if="withDelete && localValues.length"
        class="input-tags-clear"
        @click.prevent="clear"
      >
        x
      </button>
    </div>
    <slot name="between-input-tags" />
    <draggable v-if="localValues.length" v-model="localValues" group="tag" ghost-class="dragging">
      <template #item="{ element }">
        <span class="m-r-5 m-b-5 di-block">
          <slot :local-value="element" :with-delete="withDelete" :deselect="deselect">
            <span class="tag label label-info m-0">
              {{ element }}
              <span v-if="withDelete" data-role="remove" @click="deselect(element)"></span>
            </span>
          </slot>
        </span>
      </template>
    </draggable>
    <slot name="after-tags" />
  </div>
</template>

<script>
import * as vuedraggable from 'vuedraggable'

export default {
  components: {
    draggable: vuedraggable,
  },
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      type: Array,
      required: true,
    },
    multiple: {
      type: Boolean,
      // eslint-disable-next-line vue/no-boolean-default -- Baseline eslint ignore please fix if working on this
      default: () => true,
    },
    withDelete: {
      type: Boolean,
      // eslint-disable-next-line vue/no-boolean-default -- Baseline eslint ignore please fix if working on this
      default: () => true,
    },
    placeholder: {
      type: String,
      default: $t('Values here'),
    },
    separator: {
      type: String,
      default: () => ';',
    },
  },
  data() {
    return {
      input: null,
    }
  },
  computed: {
    localValues: {
      get() {
        return this.modelValue
      },
      set(val) {
        this.$emit('update:modelValue', val instanceof Array ? val : [val])
      },
    },
    parsedInput() {
      if (this.input) {
        return this.input
          .split(this.separator)
          .map((item) => item.trim())
          .filter((item) => item.length > 0)
      }
      return []
    },
  },
  methods: {
    handleBlur() {
      this.addNewValues()
    },
    handleKeydown(e) {
      if (e.key.toLowerCase() === 'enter' || e.key.toLowerCase() === ';') {
        e.preventDefault()
        this.addNewValues()
      }
    },
    clear() {
      this.localValues = []
      this.input = null
    },
    addNewValues() {
      if (this.parsedInput) {
        this.parsedInput.forEach((input) => this.localValues.push(input))
        this.localValues = this.localValues.filter(
          (value, index, self) => self.indexOf(value) === index,
        )
        this.input = null
      }
    },
    deselect(localValue) {
      this.$emit(
        'update:modelValue',
        this.localValues.filter((val) => val !== localValue),
      )
    },
  },
}
</script>

<style lang="scss">
.bootstrap-tagsinput .input-tags-input {
  margin-bottom: 10px;
}

.input-tags-field {
  position: relative;

  .input-tags-input {
    padding-right: 30px !important;
  }

  .input-tags-clear {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    padding: 0 10px;
    background: transparent;
    border: none;
  }
}
</style>
